import * as actionType from 'ActionTypes';
import { updateObj } from 'Utils';

const initialState = {
	list: [],
	originList: [],
	filtered_list: [],
	loading: false,
	error: false,
	selectedMarker: {}
};

export const MarkerReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionType.SET_MARKERS:
			return updateObj(state, {
				list: action.list,
				loading: false,
				erorr: false
			});
		case actionType.SET_FILTERED_MARKERS:
			return updateObj(state, {
				filtered_list: action.markers
			});
		case actionType.SET_ORIGIN_MARKER:
			return updateObj(state, {
				originList: action.list
			});
		case actionType.GET_MARKERS_REQUEST:
			return updateObj(state, {
				loading: true
			});
		case actionType.GET_MARKERS_FAIL:
			return updateObj(state, {
				error: true,
				loading: false
			});
		case actionType.SET_SELECTED_MARKER:
			return updateObj(state, { selectedMarker: action.selectedMarker });
		default:
			return state;
	}
};
